

import axios from "axios"
import { GETCHARGEEXP } from "../ActionTypes/ChargeTypes"



export const getchargexp = () => async (dispatch) => {
    try {
        
      const res = await axios.get('/api/ChargeExp/GetChargeExp')
            
      dispatch(
        {
        type: GETCHARGEEXP,
        payload: res.data.ChargeExpl
      });
    } catch (error) {
      console.log(error);
    }
  };

export const AddChargeExp=(newChargeExp)=>async(dispatch)=>{
     try {
         await axios.post('/api/ChargeExp/AddChargeExp',newChargeExp,{
          headers : {
              Authorised : localStorage.getItem('token')
          }
      })
         dispatch(getchargexp())
         alert("Charge d'exploitation enregistrée avec succès !");
         return true;
     } catch (error) {
         console.log(error)
         alert("Erreur lors de l'enregistrement de la charge d'exploitation.");
         return false;
     }
  }

export const updateChargeExp = (id, updatedData) => async (dispatch) => {
    try {
        await axios.put(`/api/ChargeExp/UpdateChargeExp/${id}`, updatedData, {
            headers: {
                Authorised: localStorage.getItem('token')
            }
        });
        dispatch(getchargexp());
        alert("Charge d'exploitation modifiée avec succès !");
        return true;
    } catch (error) {
        console.log(error);
        alert("Erreur lors de la modification de la charge d'exploitation.");
        return false;
    }
};

export const deleteChargeExp = (id) => async (dispatch) => {
    try {
        await axios.delete(`/api/ChargeExp/DeleteChargeExp/${id}`, {
            headers: {
                Authorised: localStorage.getItem('token')
            }
        });
        dispatch(getchargexp());
        alert("Charge d'exploitation supprimée avec succès !");
        return true;
    } catch (error) {
        console.log(error);
        alert("Erreur lors de la suppression de la charge d'exploitation.");
        return false;
    }
};